import { create } from 'zustand';

interface AddImageToClientStore {
  clientId: number;
  isOpen: boolean;
  onAddImageToClientClose: () => void;
  onAddImageToClientOpen: (clientId: number) => void;
}

export const useAddImageToClientStore = create<AddImageToClientStore>(set => ({
  clientId: 0,
  isOpen: false,
  onAddImageToClientClose: () => set({ clientId: 0, isOpen: false }),
  onAddImageToClientOpen: (clientId: number) => set({ clientId, isOpen: true }),
}));
